
jQuery.getURLParameter = function(name) {
	var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
	return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

jQuery.objectSize = function(the_object) {
	var object_size = 0;
	for (var key in the_object){ if (the_object.hasOwnProperty(key)) { object_size++; } }
	return object_size;
};

jQuery.fn.serializeObject = function() {
	var obj = {};
	jQuery.each( this.serializeArray(), function(i,o){
		var n = o.name,
		v = o.value;
		obj[n] = obj[n] === undefined ? v
			: jQuery.isArray( obj[n] ) ? obj[n].concat( v )
			: [ obj[n], v ];
	});
	return obj;
};

// jQuery plugin for positioning the cursor inside a textbox, to the end of the box...
// based on various solutions, the one that eventually worked was similar to one posted on this page :: http://stackoverflow.com/questions/4609405/set-focus-after-last-character-in-text-box
jQuery.fn.setCursorToTextEnd = function() {
	$initialVal = this.val();
	this.val($initialVal + ' ');
	this.val($initialVal);
};

// console.log simulator function for IE to prevent major javascript issues in IE when Developer Toolbar is NOT open...
if (typeof console === "undefined" || typeof console.log === "undefined") {
	console = {};
	console.log = function() {};
	console.error = function() {};
}



// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.helper.misc.js